/* eslint-disable react/require-default-props */
import React from 'react';
import { AcademyLive } from 'store/modules/academy_store/types';
import { academyDateTimeLabel, academyCountdownLabel } from 'services/academy_date';
import { Container } from './styles';

interface AcademyFeaturedEventProps {
  live: AcademyLive;
  action: React.ReactNode;
  onOpen?: () => void;
}

const AcademyFeaturedEvent: React.FC<AcademyFeaturedEventProps> = ({ live, action, onOpen }) => {
  const isLive = live.status === 'live';

  return (
    <Container
      className={onOpen ? 'clickable' : ''}
      onClick={onOpen}
      role={onOpen ? 'button' : undefined}
    >
      <div className="featured-thumb">
        {live.thumbnail_url && <img src={live.thumbnail_url} alt={live.title} />}
      </div>
      <div className="featured-head">
        <div className="featured-title">{live.title}</div>
        <div
          className="featured-action"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          role="presentation"
        >
          {action}
        </div>
      </div>
      <div className="featured-date">{academyDateTimeLabel(live.scheduled_at)}</div>
      <span className="countdown">{academyCountdownLabel(live.scheduled_at, isLive)}</span>
    </Container>
  );
};

export default AcademyFeaturedEvent;
